import { charities } from "../lib/charities";

export const getCharityLogoUrl = (charityName) => {
  const charityData = charities.filter(
    (charity) => charity.title === charityName
  );

  if (charityData && charityData.length) {
    const currentCharity =  charityData[0]
    return require(`../extensions/images/charities/${currentCharity.logo}`);
  };
};

export const getCharityLightLogoUrl = (charityName) => {
  const charityData = charities.filter(
    (charity) => charity.title === charityName
  );

  if (charityData && charityData.length) {
    const currentCharity =  charityData[0]
    return require(`../extensions/images/charities/${currentCharity.logoLight}`);
  };
};